// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__b6b0y","checkboxLabel":"Checkbox_checkboxLabel__0qYY1","checkboxInput":"Checkbox_checkboxInput__IjnDC","text":"Checkbox_text__UPb1o"};